import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController, IonContent } from '@ionic/angular';
import { Subscription, Subject } from 'rxjs';
import { PopoverComponent } from '../../shared/components/popover/popover.component';
import { SearchpopoverComponent } from '../../shared/components/searchpopover/searchpopover.component';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Page } from 'src/app/models/page.model';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage implements OnInit {

  @ViewChild('table') table: DatatableComponent;
  // @ViewChild('content') private content: IonContent;
  @ViewChild('focusconSettingName', { static: false }) focusconSettingName;
  @ViewChild('focusconSettingValue', { static: false }) focusconSettingValue;
  @ViewChild('focusconSettingGroup', { static: false }) focusconSettingGroup;

  rows = [];
  page = new Page();

  skip: number = 0;
  pageSize: number = 20;
  count: any;


  itemsSelected: any = [];
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  searchEvent: Subject<any>;

  editing = {};
  showPage: boolean = false;
  deleteCount: any = [];;
  columnsWidth: any = [];
  checkSaved:boolean;
  invalidSettingValue: boolean = false;
  invalidSettingName: boolean = false;
  scrollBar : boolean= false;

  adjustColumnWidth() {
    if (this.table && window.innerWidth > 800) {
    // this.scrollBar = false;
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.SettingName = (40 / 100) * tableWidth;
      this.columnsWidth.SettingValue = (30 / 100) * tableWidth;
      this.columnsWidth.SettingGroup = (30 / 100) * tableWidth;
    }
    if (this.table && window.innerWidth < 800) {
    //  this.scrollBar = true;
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.SettingName = (40 / 100) * tableWidth;
      this.columnsWidth.SettingValue = (30 / 100) * tableWidth;
      this.columnsWidth.SettingGroup = (30 / 100) * tableWidth;
    }
  }

  constructor(private router: Router,private el: ElementRef, private _apiService: ApiService, public _commonService: CommonService, private popoverController: PopoverController) {
    this.page.pageNumber = 0;
    this.page.size = 20;
    this.page.orderBy = '';
    this.page.orderDir = '';
    this.searchEvent = this._commonService.searchTextValue;
  }

  ngOnInit() {

  }


  public onLimitChange(limit: any): void {
    this.page.size = parseInt(limit, 10);
    if (this._commonService.searchText && this._commonService.searchText != ''){
      this.setPage({ offset: 0 }, this._commonService.searchText);
    }else{
      this.setPage({ offset: 0 }, '');
    }
  }

  ionViewDidLeave(){
    this.editing = {};
    this.itemsSelected = [];
    // this.table.selected = [];
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  ionViewDidEnter() {
    this.itemsSelected = []
    if (this.searchEvent) {
      this.searchSubscription = this.searchEvent.subscribe(event => {
        this.setPage({ offset: 0 }, event);
      });
    }
    this.setPage({ offset: 0 }, "");
    this.adjustColumnWidth();
    this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
      setTimeout( () => {
        if(this.table){
          this.rows = [...this.rows];
          this.table.recalculate();
        }
      },0)
    });
    this.resizeSubscription = this._commonService.onResize.subscribe(event => {
      this.adjustColumnWidth();
    });
  }

  /**
  * Populate the table with new data based on the page number
  * @param page The page to select
  */
  // async setPage(pageInfo, searchText) {
  //   this._commonService.presentLoading();
  //   this._apiService.getSettings(searchText ? searchText : "", this.page.orderBy, this.page.orderDir, 1, 0).then(data => {
  //     this.rows = data.body;
  //     this.showPage = true;
  //     this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
  //     this.table.selected = [];
  //     if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
  //     this._commonService.dismiss();
  //   }).catch(err => {
  //     this._commonService.dismiss();
  //     this._commonService.log(err, this._commonService.ERROR);
  //   })
  // }



  async setPage(pageInfo, searchText) {
    this._commonService.searchText = searchText;
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    this.page.pageNumber = pageInfo.offset;
    this.table.offset = this.page.pageNumber;
    this._apiService.getSettings(searchText ? searchText: "", this.page.orderBy, this.page.orderDir, this.page.pageNumber + 1, this.page.size,  ).then(data => {
    this.page.totalElements = data.headers.get('X-Page-TotalCount');
      this.showPage = true;
      this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
      this.table.selected = [];
      if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
      this.rows = data.body;
      this._commonService.log(this.rows, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
  }





  onSelect(event) {
    let selected = []
    if(event.selected){

      event.selected.forEach(element => {
        if(element.SettingId && element.SettingId != "empty"){

          selected.push(element.SettingId);
        } else{
          element.SettingId = "empty"
          selected.push(element.SettingId);
        }
      });

      this.itemsSelected = selected;
      this.deleteCount = this.itemsSelected.filter(e => e != 'empty');

      // if(event.selected.length > 0){
      //   this.itemsSelected.push(event.selected[event.selected.length -  1].SettingId);
      //   this.table.selected.push(event.selected[event.selected.length -  1])
      // }

    }
  }

  async onChangePage(pageData) {
    this.skip = pageData.skip;
    this.pageSize = pageData.pageSize;
    this.setPage(this.pageSize, '');
  }
  // singleSelectCheck(row: any) {
  //   let selected = [];
  //   let index = this.itemsSelected.indexOf(row.SettingId) === -1;
  //   if(index) {
  //     selected.push(row.SettingId);
  //     this.itemsSelected = selected;
  //   }else{
  //     this.itemsSelected = selected;
  //   }
  //   return index;
  // }

  async presentPopover(event: any) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      componentProps: { route: "domains/0", itemsSelected: this.itemsSelected, deleteRoute: "Domains" },
      event: event,
      showBackdrop: false,
      cssClass: 'popPopOver',
      translucent: true
    });
    return await popover.present();

  }

  async presentSearchPopover(event: any) {
    const popover = await this.popoverController.create({
      component: SearchpopoverComponent,
      event: event,
      translucent: false,
      cssClass: 'searchPopOver'
    });
    return await popover.present();
  }

  updateValue(event, cell, rowIndex, row) {
    if(cell == "SettingName"){
      if(row.isSettingNameInvalid && event.target.value != "") {
        row.isSettingNameInvalid = false;
        this.invalidSettingName = false;
      }
    }
    if(cell == "SettingValue"){
    if(row.isSettingValueInvalid && event.target.value != "") {
      row.isSettingValueInvalid = false;
      this.invalidSettingValue = false;
    }
  }
    if(event.target.value != "" || this.rows[rowIndex][cell] !="" ){
      if(event.target.value != "" || event.target.value == row[cell]) {
        this.editing[rowIndex + '-' + cell] = false;
      }
      this.rows[rowIndex][cell] = event.target.value;
      let rowArray =[];
      rowArray.push(row);
      if(this.rows[rowIndex][cell] != row[cell]) {
        rowArray[rowIndex][cell] = event.target.value
      }
      this.rows = [...this.rows];
    }
  }

  goBack() {
    this._commonService.goBack('maintenance');
  }

  add(){
    this.checkSaved = false;
    this.rows.push({
      SettingGroup: "",
      SettingId: null,
      SettingName: "",
      SettingValue: ""
    })
    this.rows = [...this.rows];
    this.editing[this.table.rowCount + '-SettingName'] = true;
    this.editing[this.table.rowCount + '-SettingValue'] = true;
    this.editing[this.table.rowCount + '-SettingGroup'] = true;
        setTimeout(() => {
    this.table.element.querySelector('.datatable-body').scrollTop = (this.rows.length + 1) * 50;
    if(this.table._internalRows[(this.rows.length-1)].SettingName == "") {
      this.focusconSettingName.setFocus();
    }
  }, 0);
    // const firstInvalidControl = this.el.nativeElement.querySelector(
    //   ".datatable-body-row.datatable-body-row.active"
    // );

    // firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });;
    // setTimeout(() => {
    //   if (this.content.scrollToBottom) {
    //     this.content.scrollToBottom(500);
    //   }
    // },0);
  }

  focusAndEdit(cell, rowIndex) {
    this.editing[rowIndex + '-' + cell] = true;
    setTimeout(() => {
      if(cell == "SettingName") {
        this.focusconSettingName.setFocus();
      } else if(cell == "SettingValue") {
        this.focusconSettingValue.setFocus();
      } else if(cell == "SettingGroup") {
        this.focusconSettingGroup.setFocus();
      }
    }, 0);
  }
  async onSubmit(){
    this.table._internalRows.forEach( row => {
      if(row.SettingName == "") {
        row.isSettingNameInvalid = true;
        this.invalidSettingName = true;
      } else {
        row.isSettingNameInvalid = false;
      }
      if(row.SettingValue == "") {
        row.isSettingValueInvalid = true;
        this.invalidSettingValue = true;
      } else {
        row.isSettingValueInvalid = false;
      }
     });
     if(this.invalidSettingName || this.invalidSettingValue){
       let rows = [];
      for (let i = 0; i < this.table._internalRows.length; i++) {
        if(this.table._internalRows[i].isSettingNameInvalid || this.table._internalRows[i].isSettingValueInvalid) {
         rows.push(i)
        }
      }
      setTimeout(() => {
        if(this.table._internalRows[rows[0]].isSettingNameInvalid) {
          this.focusconSettingName.setFocus();
        } else if(this.table._internalRows[rows[0]].isSettingValueInvalid) {
          this.focusconSettingValue.setFocus();
        }
        this.table.element.querySelector('.datatable-body').scrollTop = rows[0] * 50;
      }, 0);
      this.invalidSettingName = false;
      this.invalidSettingValue = false;
       return;
     }
    this._commonService.presentLoading();
    try {
      let data = [];
      let color = "";
      let colorSecondary = "";
      this.rows.forEach( row => {
        if (row.SettingName != "" && row.SettingValue != ""){
          row.SettingName = row.SettingName.trim();
          data.push(row);
        }
        if (row.SettingName.toLowerCase() == "color" && row.SettingValue != ""){
          if (!(this._commonService.isColor(row.SettingValue.toLowerCase()))){
            row.SettingValue = '#063932';
          }
          color = row.SettingValue.toLowerCase();
        }
        if (row.SettingName.toLowerCase() == "colorsecondary" && row.SettingValue != "") {
          if (!(this._commonService.isColor(row.SettingValue.toLowerCase()))) {
            row.SettingValue = '#127668';
          }
          colorSecondary = row.SettingValue.toLowerCase();
        }
      });
      this._commonService.log(data, this._commonService.LOG);
      await this._apiService.putSetting(data);
      var i=0;
      this.rows.forEach( row => {
        i++;
      this.editing[i + '-SettingName'] = false;
      this.editing[i + '-SettingValue'] = false;
      this.editing[i + '-SettingGroup'] = false;
      });

      this._commonService.dismiss();
      this.setPage({ offset: 0 }, "");
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          this.itemsSelected.forEach(async (element) => {
            if (element == "empty") {
              // let a=this.rows.slice(-1);
              this.itemsSelected = this.itemsSelected.filter(e => e != "empty")
              if(this.deleteCount.length == 0){
                this._commonService.dismiss();
                this.rows = this.rows.filter(e => e.SettingId != "empty");
              }
            }
          });
          if (this.itemsSelected.length > 0) {
            await this._apiService.deleteSetting(this.itemsSelected);
            this._commonService.log(res, this._commonService.LOG);
            this._commonService.dismiss();
            this.table.selected = [];
            this.itemsSelected = [];
            this.deleteCount = [];
            this.setPage({ offset: 0 }, '');
          }

        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  async onSort(event) {
    const sort = event.sorts[0];
    this.page.orderBy = sort.prop.toLowerCase();
    this.page.orderDir = sort.dir;
    this.setPage({ offset: this.page.pageNumber }, '');
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "add":
          this.add();
          break;
      case "delete":
          this.delete();
          break;
      case "search":
          this.itemsSelected=[];
          this.setPage({ offset: 0 }, obj.Event);
          break;
      case "close":
        this.itemsSelected=[];
          this.setPage({ offset: 0 }, "");
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true });
          break;
      case "back":
          this.goBack();
          break;
      }
  }

}
